import { render, staticRenderFns } from "./Rentabilidade.vue?vue&type=template&id=1982b9c8"
import script from "./Rentabilidade.vue?vue&type=script&lang=js"
export * from "./Rentabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports